import "../../../static/js/loaders/jquery";
if (document.querySelector('.carousel') !== null) {
    $('.carousel').carousel()
}